import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import {push} from 'connected-react-router';
import {SMCPaths} from '../conf/Routes';
import Api from '../api/SMPFetchHelper';
import {useSMCErrorHandler} from '../utils/errorUtils';
import {useSMCSnackbar} from '../utils/hooks';
import SMCPageLoading from '../components/core/pageComponents/SMCPageLoading';
import {useTranslation} from 'react-i18next';

function GenericUserEditor({
    urlParams,
    navigateTo
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();
    const { enqueueErrorSnackbar } = useSMCSnackbar();
    
    const queryParams = queryString.parse(urlParams);
    const id = queryParams?.id;
    if (!id) {
        navigateTo(SMCPaths.home);
    }
    else {
        Api.getUserType(id)
        .then(resp => {
            const respData = resp.data.data;
            if (!respData.isExists) {
                enqueueErrorSnackbar(t('com.sofaware.db.OBJECT_NOT_FOUND', [t('com.sofaware.util.TYPE_USER'), id]));
                navigateTo(SMCPaths.home);
            }
            else if (respData.type === 'users') {
                navigateTo(SMCPaths.users+'?id='+id);
            }
            else if (respData.type === 'administrators') {
                navigateTo(SMCPaths.administrators+'?id='+id);
            }
            else if (respData.type === 'systemUsers') {
                navigateTo(SMCPaths.systemUsers+'?id='+id);
            }
            else {
                enqueueErrorSnackbar(t('com.sofaware.db.OBJECT_NOT_FOUND', [t('com.sofaware.util.TYPE_USER'), id]));
                navigateTo(SMCPaths.home);
            }
        })
        .catch(e => {
            const errorMessage = getErrorMessage(e);
            console.error(errorMessage);
            enqueueErrorSnackbar(t('com.sofaware.db.OBJECT_NOT_FOUND', [t('com.sofaware.util.TYPE_USER'), id]));
            navigateTo(SMCPaths.home);
        })
    }
    return (
        <SMCPageLoading />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search
});

const mapDispatchToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapDispatchToProps)(GenericUserEditor);